<template>
  <div
    class="fixed-btn"
    v-if="showOrderReport"
  >
    <!-- 悬浮按钮 订单报备 -->
    <img
      src="@/assets/img/orderReport/order-report.png"
      @click="toPage"
    >
  </div>
</template>

<script>
import { ORDER_STATUS_CODE } from '@/common/constant';
import jsApi from '@/common/jsApi';
export default {
  name: 'OrderReport',
  props: {
    taskDetail: {
      type: Object,
      required: true
    },
    isInApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    showOrderReport() {
      // 道路救援、困境救援、事故救援订单状态为处理中时 展示报备入口
      const { universalRescue, orderStatus } = this.taskDetail;
      return universalRescue && [ORDER_STATUS_CODE.processing].includes(orderStatus);
    },
    orderNo() {
      return this.taskDetail?.orderNo;
    },
    taskNo() {
      return this.taskDetail?.taskNo;
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 页面跳转
    toPage() {
      if (this.isInApp) {
        const url = window.location.href.split('#')[0];
        const detailUrl = `${url}#/orderReport/appBase/${this.orderNo}/${this.taskNo}`;
        jsApi.openWebView({
          url: detailUrl,
          title: '在线报备'
        });
      } else {
        const router = {
          name: this.isInApp ? 'OrderReportAppBase' : 'OrderReportBase',
          params: {
            orderNo: this.orderNo
          }
        };
        this.$router.push(router);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-btn{
  position: fixed;
  right: 10px;
  bottom: 256px;

  width: 60px;
  height: 60px;

  img{
    width: 100%;
    height: 100%;
  }
}
</style>
